import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Country } from '../model/geo/country.model';
import { State } from '../model/geo/state.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class GeoService {

  countryLoad: Country[];
  country: any;
  countries: any[];

  constructor(private firestore: AngularFirestore, private http: HttpClient) { }

  getCountry(countryQuery: string): Country {
    return this.country;
  }

  getCountries() {
    //this.loadGeo()
    return this.firestore.collection('geo').snapshotChanges();
  }

  getStates(country: Country) {
    return country.states;
  }

  createCities(state: State) {
    return state.cities;
  }

  loadGeo() {
    console.log('loadGeo()');
    this.getCitiesJSON().subscribe(data => {
      data.forEach(country => {
        this.firestore.collection('geo').add(country);
      });

    });

  }

  getCitiesJSON(): Observable<any> {
    return this.http.get("assets/data/geo_cities.json");
  }
}
